<template>
  <el-container style="justify-content: center; padding: 40px" v-loading.fullscreen.lock="loading">
    <el-col :xs="22" :sm="14" :md="10" :lg="8">
      <h2>Prueba de recibo</h2>
      <el-form label-position="top" @submit.prevent.native>
        <el-form-item label="OID / Cuenta predial">
          <el-input v-model="oid" placeholder="Ej: 8706522" />
        </el-form-item>
        <el-button type="primary" style="width: 100%" @click="cargarRecibo" :loading="loading">
          Cargar recibo
        </el-button>
      </el-form>
      <p v-if="error" style="color: red; margin-top: 15px">{{ error }}</p>
    </el-col>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      oid: this.$route.query.id || '',
      loading: false,
      error: null,
    };
  },
  methods: {
    async cargarRecibo() {
      if (!this.oid) return;
      this.loading = true;
      this.error = null;
      try {
        const res = await this.axios.get(`/InformacionRecibo/${this.oid}`);
        const reciboPDF = res.data.recibo;
        if (!reciboPDF) {
          this.error = `La API respondió pero sin campo 'recibo'. Respuesta: ${JSON.stringify(res.data)}`;
          return;
        }
        this.$store.dispatch('receipt/SET_DATA', {
          tipo: 'pago-predial',
          reciboPDF,
        });
        this.$router.push({ path: '/recibo-pdf' });
      } catch (err) {
        this.error = `Error ${err?.response?.status || ''}: ${err?.response?.data?.message || err.message}`;
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.oid) this.cargarRecibo();
  },
};
</script>
